"use client";

import { TextField } from "@mui/material";
import { useEffect, useRef } from "react";

const OtpInput = ({ totalDigits = 6, value = "", onChange }) => {
  const inputContainerRef = useRef();
  const digits = value.split("");

  useEffect(() => {
    inputContainerRef.current.childNodes[0]
      .getElementsByTagName("input")[0]
      .focus();
  }, []);

  const digitEnter = (e) => {
    const textValue = [...inputContainerRef.current.childNodes]
      .map(
        (inpContainer) =>
          inpContainer.getElementsByTagName("input")[0].value ?? ""
      )
      .join("");
    onChange(textValue);

    if (e.target.name < totalDigits - 1 && e.target.value) {
      inputContainerRef.current.childNodes[
        parseInt(e.target.name) + 1
      ].getElementsByTagName("input")[0].disabled = false;
      inputContainerRef.current.childNodes[
        parseInt(e.target.name) + 1
      ].getElementsByTagName("input")[0].focus();
    }
  };

  const handleKeyDown = (e) => {
    const idx = parseInt(e.target.name);
    if (e.key === "Backspace") {
      if (e.target.value === "" && idx > 0) {
        inputContainerRef.current.childNodes[idx - 1]
          .getElementsByTagName("input")[0]
          .focus();
      }
    }
  };

  const pasteOtp = (e) => {
    onChange(e.clipboardData.getData("text"));
  };

  return (
    <div className="flex gap-4" ref={inputContainerRef}>
      {Array.from({ length: totalDigits }, (_, idx) => {
        return (
          <TextField
            sx={{ height: "40px", width: "40px" }}
            value={digits[idx] ?? ""}
            disabled={idx > digits.length}
            onChange={digitEnter}
            onKeyDown={handleKeyDown}
            key={idx}
            name={idx}
            onPaste={pasteOtp}
            slotProps={{
              htmlInput: {
                maxLength: 1,
                style: {
                  textAlign: "center",
                },
              },
            }}
          />
        );
      })}
    </div>
  );
};

export default OtpInput;
